<template>
<div class="list-group">
	<div v-if="showSearch" class="mb-3"> 
		<div class="btn-toolbar-item input-with-icon">
			<input type="text" class="form-control input-block" placeholder="search" v-model="search" @input="searchChanged">
			<span class="icon icon-magnifying-glass"></span>				
		</div>
	</div>
	<h6 v-else class="list-group-header">{{heading}}</h6>
	<slot></slot>
</div>
</template>

<script>

	export default {
		name: 'ListGroup',
		props: {
			heading: String,
			showSearch: Boolean
		},
		data() {
			return {
				search:''
			}
		},
		methods: {
			searchChanged: debounce(function() {
				this.$emit('search-changed', this.search);
			}, 250)
		}
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
</script>


// WEBPACK FOOTER //
// src/components/ListGroup.vue